export const environment = {
  production: false,
  mapboxKey:
    'pk.eyJ1IjoieWVyc29uZGV2IiwiYSI6ImNsbWQwbWoyYzFha2ozaHM2Znp0czU2ZWkifQ.gz8ql042zWS-LuMudkZfKQ',
  // API_URL: 'https://aktha.app/api/',
  API_URL: '/api/',
  //URL: 'https://localhost:4200/',
  URL: 'https://qa.aktha.app/',
  //URL: 'https://dev.aktha.app/',
  //URL: 'https://core.aktha.app/',
  logLevel: 'debug',

  CLIENT_ID: 'aktha',
  CLIENT_SECRET: 'G3iIHawkPqEl3Mo8FmJzl3uiplLLUtiA',
  googleKey: 'AIzaSyCjb8Drx2IjLulLVcL2_e1VdFsaX2hswPY',
};
